import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import useResponsive from "../hooks/responsive";
import {trackGaussEvent} from "../helper/analytics";

export default function CourseNotes({courseId, defaultLesonSlug = 'none'}) {
    const [isMobile, maxWidthSize] = useResponsive()
    const [isActiveOnMenu, setIsActiveOnMenu] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [selectedVideo, setSelectedVideo] = useState(defaultLesonSlug)


    useEffect(() => {
        const listener = (event) => {
            const leason = event.detail
            setSelectedVideo(leason.slug)
            // load
        }

        document.addEventListener('course_select_video', listener)

        return () => {
            document.removeEventListener('course_select_video', listener)
        }
    }, [])

    const keyCache = `course_notes_${courseId}_${selectedVideo}`

    function hydrateValue() {
        const d = localStorage.getItem(keyCache)
        if (d) {
            setDefaultValue(d)
        } else {
            setDefaultValue(null)
        }
    }


    useEffect(() => {
        hydrateValue()
        if(isActiveOnMenu) {
            trackGaussEvent('opening_notes', {
                leason:  selectedVideo ? selectedVideo : 'none'
            })
        }

    }, [selectedVideo, isActiveOnMenu])

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'notes')
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    const onChange = (event) => {
        const value = event.target.value
        localStorage.setItem(keyCache, value)
        if(value.length === 0) localStorage.removeItem(keyCache)
    }

    if(!isActiveOnMenu) return null;

    return (
        <Container >
            <InputTextarea
                isMobile={isMobile} maxWidth={maxWidthSize}
                defaultValue={defaultValue}
                onChange={onChange} placeholder="Aqui puedes tomar tus notas"></InputTextarea>
        </Container>
    )
}

const Container = styled.div`
    position: absolute;
    margin-top: -70px;
`

const InputTextarea = styled.textarea`
    width: ${props => props.isMobile ? '89vw' : '362px'};
    height: calc(100vh - 206px);
    margin-left: 4px;
`



if (document.getElementsByTagName('course-menu-notes')) {
    const elms = document.getElementsByTagName('course-menu-notes')

    for(let elm of elms) {
        const courseId = elm.attributes['course-id'].value
        const lesonSlug = elm.attributes['default-leson-slug'] ? elm.attributes['default-leson-slug'].value : 'none'
        ReactDOM.render(<CourseNotes courseId={courseId} defaultLesonSlug={lesonSlug} />, elm);
    }
}
